module.exports = {
  environment: "DEVELOPMENT"
};
